import actions from '../../actionTypes';

export default (status) => {
  return {
    type: actions.FORGOT_PASSWORD_COMPLETED,
    status
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/forgotPasswordCompleted.js